<template>
  <div class="rolesList">

    <b-row>
      <b-col>
          <roles-add @refreshList="refrescarLista"></roles-add>
      </b-col>
    </b-row>

    <!-- SPACER-->
    <spacer-card></spacer-card>
    <!-- SPACER-->

    <b-row>
      <b-col>
        <roles-edit ref="editarroles"></roles-edit>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import Spacer from '@/components/card/Spacer';
import RolesAdd from '@/components/roles/RolesAdd';
import RolesEdit from '@/components/roles/RolesEdit';

export default {
    data () {
        return {
          
        }
    },
    methods : {
      refrescarLista(){
        this.$refs.editarroles.resetValues();
      }
    },
    components: {
      'spacer-card': Spacer,
      'roles-add': RolesAdd,
      'roles-edit': RolesEdit
    }
}
</script>

<style scoped>

</style>